// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnalyticsEventController from "./analytics_event_controller"
application.register("analytics-event", AnalyticsEventController)

import AppBadgeController from "./app_badge_controller"
application.register("app-badge", AppBadgeController)

import AvatarPreviewController from "./avatar_preview_controller"
application.register("avatar-preview", AvatarPreviewController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import EmojiInputController from "./emoji_input_controller"
application.register("emoji-input", EmojiInputController)

import FilterableController from "./filterable_controller"
application.register("filterable", FilterableController)

import Modal from "./modal"
application.register("modal", Modal)

import NotificationRequestorController from "./notification_requestor_controller"
application.register("notification-requestor", NotificationRequestorController)

import Sortable from "./sortable"
application.register("sortable", Sortable)

import RemovableController from "./removable_controller"
application.register("removable", RemovableController)

import SelfDestructController from "./self_destruct_controller"
application.register("self-destruct", SelfDestructController)

import TransitionController from "./transition_controller"
application.register("transition", TransitionController)

import UserToggleController from "./user_toggle_controller"
application.register("user-toggle", UserToggleController)
